import { combineReducers } from 'redux';
import userReducer from './userReducer';
import countriesReducer from './countriesReducer';
import checkPinReducer from './checkPinReducer';
import modalReducer from './modalReducer';
import profileReducer from './profileReducer';
import valueDriverReducer from './valueDriverReducer';
import managmentReducer from './managmentReducer';
import driverReducer from './driverReducer';
import busyReducer from './busyReducer';
import vehicleReducer from './vehicleReducer';
import levelpathReducer from './levelpathReducer';
import sublevelReducer from './sublevelReducer';
import modelsReducer from './modelsReducer';
import intlReducer from './intlReducer';

const rootReducer = combineReducers({
  account: userReducer,
  countries: countriesReducer,
  checkpin: checkPinReducer,
  modal: modalReducer,
  profile: profileReducer,
  driver: valueDriverReducer,
  managment: managmentReducer,
  drivers: driverReducer,
  vehicles: vehicleReducer,
  busy: busyReducer,
  levelpath: levelpathReducer,
  sublevel: sublevelReducer,
  models: modelsReducer,
  intl: intlReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
